export default {
  login : (store)=>{
    return store.commit('setLogin', true);
  },
  logout : (store)=>{
    return store.commit('setLogin', false);
  },
}
